import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Divider, IconButton, ClickAwayListener, Typography, Box, CircularProgress } from '@material-ui/core';
import settings from '../../../utils/settings';
import clsx from 'clsx';
import { get, capitalize, cloneDeep, isEmpty, findIndex } from 'lodash';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import moment from 'moment';
import {
  getApplicationNotifications,
  markNotificationSeen,
  readApplicationNotification,
  deleteReadNotification
} from '../../../containers/Layouts/actions';
import BellIcon from '../Icons/Bell';
import LightTooltipHeader from '../LightTooltip';

const styles = theme => ({
  iconButton: {
    padding: '0 !important',
    marginRight: `${theme.spacing(4.5)}px !important`,
    borderRadius: '0 !important',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  menuIcon: {
    cursor: 'pointer !important',
    color: `${theme.palette.secondary.main} !important`
  },
  relativePosition: {
    position: 'relative'
  },
  resizeIcon: {
    height: theme.spacing(3.5),
    width: theme.spacing(3),
    position: 'relative'
  },
  iconCountNotificationWrapper: {
    position: 'absolute',
    top: theme.spacing(-0.75),
    left: theme.spacing(1.5),
    backgroundColor: theme.palette.primary.white,
    color: theme.palette.primary.main,
    borderRadius: '50%',
    height: '74%',
    width: '80%',
    fontSize: theme.spacing(2),
    textAlign: 'center',
    fontWeight: 'bold'
  },
  overflowWrapper: {
    maxHeight: theme.spacing(49),
    overflow: 'scroll'
  },
  notificationWrapperHeight: {
    maxHeight: theme.spacing(49),
    overflow: 'hidden'
  },
  mainNotificationWrapper: {
    display: 'flex',
    cursor: 'pointer'
  },
  greyBackgroundReadNotification: {
    backgroundColor: '#f5f5f5'
  },
  styleRightArrowIcon: {
    padding: theme.spacing(0),
    color: theme.palette.primary.main,
    '&:hover': {
      background: 'none'
    }
  },
  rightArrowStyle: {
    fontSize: theme.spacing(4.5)
  },
  notificationWrapper: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(3)
  },
  backgroundColorPermit: {
    backgroundColor: '#00C0E3'
  },
  backgroundColorSgip: {
    backgroundColor: '#5BAF2A'
  },
  backgroundColorDrs: {
    backgroundColor: '#F37320'
  },
  styleTypeWrapper: {
    borderRadius: theme.spacing(1),
    textAlign: 'center',
    width: 'fit-content',
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(0.75)
  },
  styleType: {
    fontSize: theme.spacing(1.5),
    color: '#FFF'
  },
  notificationTextWrapper: {
    backgroundColor: '#E2E6EA',
    width: '100%',
    position: 'relative',
    height: theme.spacing(5)
  },
  notificationTextStyle: {
    position: 'absolute',
    top: '22%',
    marginLeft: theme.spacing(2),
    fontWeight: 'bold',
    color: '#2F2F2F'
  },
  styleIdText: {
    color: '#5F5F5F',
    fontSize: theme.spacing(1.75),
    marginTop: theme.spacing(0.375)
  },
  boldIdText: {
    color: '#3B3B3B',
    fontSize: theme.spacing(1.875),
    fontWeight: 'bold'
  },
  styleTimeAgo: {
    color: '#919191',
    fontSize: theme.spacing(1.25),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(0.375)
  },
  viewAllWrapper: {
    backgroundColor: '#f5f5f5',
    position: 'relative',
    height: theme.spacing(3.75)
  },
  viewAllStyle: {
    position: 'absolute',
    top: '20%',
    fontSize: theme.spacing(1.5),
    color: '#0D83F5',
    marginLeft: theme.spacing(1.5),
    cursor: 'pointer'
  },
  noNotificationWrapper: {
    alignItems: 'center',
    color: '#919191',
    padding: theme.spacing(1.25)
  },
  styleNotificationLoaderWrapper: {
    textAlign: 'center',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5)
  },
  styleNoMoreText: {
    textAlign: 'center',
    color: '#919191'
  },
  customIconButtom: {
    [theme.breakpoints.between(1200, 1360)]: {
      marginRight: `${theme.spacing(3.5)}px !important`
    }
  }
});

class NotificationCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationDropdownOpen: false,
      viewAllClicked: false,
      notificationListState: [],
      page: 1,
      callScrollingApi: true,
      isScrolling: false,
      unseenNotificationCountState: 0
    };
    this.windowWidth = window.innerWidth;
    this.interval = null;
    this.intervalDuration = 7500;
  }

  notificationListSet = false;
  isNotificationIconClicked = false;

  setIntervalNotification = () => {
    clearTimeout(this.interval);
    this.props.getApplicationNotifications({});
    //starting with 20 seconds and stepping till 320 seconds while doubling it
    this.intervalDuration = this.intervalDuration < 320000 ? this.intervalDuration * 2 : this.intervalDuration;
    this.interval = setTimeout(() => {
      this.setIntervalNotification();
    }, this.intervalDuration);
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowReSize);
    window.addEventListener("blur", () => {
      setTimeout(() => {
        if (document.activeElement.tagName === "IFRAME") {
          this.handleNotificationDropdown(false);
        }
      });
    });
    this.props.getApplicationNotifications({});
    this.setIntervalNotification();
  }

  componentDidUpdate(prevProps, prevState) {
    const { notificationList } = this.props;
    if (
      (!this.notificationListSet && notificationList && notificationList.length > 0) ||
      prevProps.unseenNotificationCount !== this.props.unseenNotificationCount
    ) {
      this.setState({
        notificationListState: notificationList,
        unseenNotificationCountState: this.props.unseenNotificationCount
      });
      this.notificationListSet = true;
    }
    if (this.isNotificationIconClicked) {
      if (this.state.notificationDropdownOpen) {
        clearTimeout(this.interval);
      } else {
        clearTimeout(this.interval);
        this.setIntervalNotification();
      }
      this.isNotificationIconClicked = false;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowReSize);
    clearTimeout(this.interval);
  }

  handleWindowReSize = () => {
    if (this.windowWidth !== window.innerWidth) {
      this.windowWidth = window.innerWidth;
      this.handleNotificationDropdown(false);
    }
  };

  handleNotificationDropdown = isOpen => {
    this.setState({ notificationDropdownOpen: isOpen });
    this.isNotificationIconClicked = true;
    if (!isOpen) {
      this.setState({ viewAllClicked: false });
    } else {
      this.setState({ unseenNotificationCountState: 0 });
      const renderNotificationList = get(this.state, 'notificationListState', []);
      const lastUpdatedAt =
        renderNotificationList.length > 0 ? moment(renderNotificationList[0]['updated_at']).valueOf() : '0';
      this.props.markNotificationSeen({
        lastUpdatedAt: lastUpdatedAt
      });
    }
  };

  handleViewAllClicked = () => {
    this.setState({ viewAllClicked: true });
  };

  getContent = notification => {
    const { type_id, content, count } = notification;
    let result;
    if (type_id === 'UNREAD_MESSAGES') {
      if (count > 1) result = `There are ${count} unread messages available`;
      else result = `There is 1 unread message`;
    } else if (type_id === 'APPLICATION_COMPLETED' || type_id === 'APPLICATION_STATUS_UPDATE') {
      if (!isEmpty(content)) {
        result = content;
      } else {
        result = `Application status updated`;
      }
    } else {
      result = content;
    }
    return result;
  };

  getApplicationUrl = (id, service, siteId) => {
    const serviceName = service.toLowerCase();
    if (serviceName === 'permit') {
      return `${settings.enlightenMenuUrl('manager/dashboard')}/${siteId}/permitting-assistance/${id}?origin=self`;
    }
    //TODO - add correct application links for lead
    if (serviceName === 'sgip') {
      return `${settings.enlightenMenuUrl('manager/dashboard')}/sgip-incentive/applications?siteId=${siteId}`;
    }
    if (serviceName === 'drs') {
      return `${settings.drsUiUrl(`manager/dashboard/${siteId}/design-review/${id}/application-status`)}`;
    }
    return '';
  };

  handleReadNotificationHeader = (notificationId, typeId, service, service_ref_id, siteId, notificationRead) => {
    const { readApplicationNotification, deleteReadNotification } = this.props;
    const markAsRead = () => {
      this.handleNotificationDropdown(false);
      window.open(this.getApplicationUrl(service_ref_id, service, siteId), '_blank');
    };
    if (typeId === 'UNREAD_MESSAGES') {
      markAsRead();
      let clonedList = cloneDeep(this.state.notificationListState);
      clonedList = clonedList.filter(notification => {
        if (notification.id === notificationId) {
          return false;
        }
        return true;
      });
      this.setState({ notificationListState: clonedList });
      deleteReadNotification({
        notificationId: notificationId
      });
    } else {
      let clonedList = cloneDeep(this.state.notificationListState);
      const matchingNotificationIndex = findIndex(clonedList, notification => notification.id === notificationId);
      if (isEmpty(get(clonedList[matchingNotificationIndex], 'opened', []))) {
        const openedObject = {
          at: new Date().toISOString(),
          email: get(this.props.accountDetail, 'email', ''),
          userId: get(this.props.accountDetail, 'user_id', '')
        };
        clonedList[matchingNotificationIndex]['opened'] = [];
        clonedList[matchingNotificationIndex]['opened'].push(openedObject);
      }
      this.setState({ notificationListState: clonedList });
      markAsRead();
      !notificationRead &&
        readApplicationNotification({
          installerId: notificationId
        });
    }
  };

  isNotificationOpened = (opened = []) => {
    if (!opened) return false;
    const { accountDetail } = this.props;
    const emailId = get(accountDetail, 'email', '');
    const isOpened = opened.filter(value => {
      return value['email'] === emailId;
    });
    return isOpened.length > 0;
  };

  handleScroll = async e => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const { getApplicationNotifications } = this.props;
    if (bottom && this.state.callScrollingApi) {
      this.setState({ isScrolling: true });
      await getApplicationNotifications({
        page: this.state.page,
        size: 20,
        successCbk: result => {
          if (result.length > 0) {
            let clonedList = cloneDeep(this.state.notificationListState);
            clonedList = clonedList.concat(result);
            this.setState({
              notificationListState: clonedList,
              page: this.state.page + 1,
              callScrollingApi: true,
              isScrolling: false
            });
          } else {
            this.setState({ callScrollingApi: false, isScrolling: false });
          }
        }
      });
    }
  };

  getService = service => {
    if (service.toLowerCase() === 'sgip' || service.toLowerCase() === 'drs') return service.toUpperCase();
    return capitalize(service);
  };

  getNotificationContent = () => {
    const notificationList = this.state.notificationListState;
    const { classes } = this.props;
    const { isScrolling, callScrollingApi } = this.state;
    if (notificationList.length > 0) {
      return (
        <Box
          className={clsx(this.state.viewAllClicked ? classes.overflowWrapper : classes.notificationWrapperHeight)}
          onScroll={this.handleScroll}
        >
          {notificationList.map((notification, index) => {
            const { id, type_id, service_ref_id, updated_at, opened = [], site_id } = notification;
            const service = get(notification, 'service') ? get(notification, 'service').toLowerCase() : '';
            const notificationRead = this.isNotificationOpened(opened);

            return (
              <Fragment key={service + index}>
                <Box
                  className={clsx(
                    classes.mainNotificationWrapper,
                    notificationRead && classes.greyBackgroundReadNotification
                  )}
                  onClick={() => {
                    this.handleReadNotificationHeader(id, type_id, service, service_ref_id, site_id, notificationRead);
                  }}
                >
                  <Box className={classes.notificationWrapper}>
                    <Box className={clsx(classes.styleTypeWrapper, classes[`backgroundColor${capitalize(service)}`])}>
                      <Typography className={classes.styleType}>{this.getService(service)}</Typography>
                    </Box>
                    <Typography className={classes.styleIdText}>{`Request Id:${service_ref_id}`}</Typography>
                    <Typography className={classes.boldIdText}>{this.getContent(notification)}</Typography>
                    <Typography className={classes.styleTimeAgo}>{moment(updated_at).fromNow()}</Typography>
                  </Box>
                  <IconButton className={classes.styleRightArrowIcon}>
                    <ChevronRightIcon className={classes.rightArrowStyle} />
                  </IconButton>
                </Box>
                <Divider />
              </Fragment>
            );
          })}
          {isScrolling ? (
            <Box className={classes.styleNotificationLoaderWrapper}>
              <CircularProgress size={24} />
            </Box>
          ) : !callScrollingApi ? (
            <Typography className={classes.styleNoMoreText}>No more notifications to display</Typography>
          ) : null}
        </Box>
      );
    } else {
      return (
        <Box className={classes.noNotificationWrapper}>
          <Typography>No notifications available</Typography>
        </Box>
      );
    }
  };

  notificationPanel = () => {
    const notificationList = this.state.notificationListState;
    const notificationCount = notificationList.length;
    const { classes, notificationRequestSending } = this.props;
    return (
      <ClickAwayListener
        onClickAway={() => {
          this.handleNotificationDropdown(false);
        }}
      >
        <Box>
          <Box className={classes.notificationTextWrapper}>
            <Typography className={classes.notificationTextStyle}>Service Notifications</Typography>
          </Box>
          {!this.state.viewAllClicked && notificationRequestSending ? (
            <Box className={classes.styleNotificationLoaderWrapper}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            this.getNotificationContent()
          )}
          {notificationCount > 4 &&
          !this.state.viewAllClicked && (
            <Box
              className={classes.viewAllWrapper}
              onClick={() => {
                this.handleViewAllClicked();
              }}
            >
              <Typography className={classes.viewAllStyle}>View All</Typography>
            </Box>
          )}
        </Box>
      </ClickAwayListener>
    );
  };

  render() {
    const { classes, isAdminTabsEnabled, isMobileView = false } = this.props;
    const { notificationDropdownOpen, unseenNotificationCountState } = this.state;
    return (
      <LightTooltipHeader
        onClose={() => this.handleNotificationDropdown(false)}
        open={this.state.notificationDropdownOpen}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={this.notificationPanel()}
        arrow
        placement="bottom-end"
        notification="notificationCenter"
      >
        <IconButton
          className={clsx(
            classes.iconButton,
            classes.menuIcon,
            classes.relativePosition,
            !isMobileView && isAdminTabsEnabled && classes.customIconButtom
          )}
          onClick={() => this.handleNotificationDropdown(!notificationDropdownOpen)}
          id="notificationCenterIcon"
        >
          <BellIcon />
          {unseenNotificationCountState > 0 && (
            <Box className={classes.iconCountNotificationWrapper}>{unseenNotificationCountState}</Box>
          )}
        </IconButton>
      </LightTooltipHeader>
    );
  }
}

NotificationCenter.propTypes = {
  accountDetail: PropTypes.object
};

const mapStateToProps = state => ({
  notificationList: state.defaultReducer.notificationList,
  unseenNotificationCount: state.defaultReducer.unseenNotificationCount,
  notificationRequestSending: state.defaultReducer.notificationRequestSending
});

const mapDispatchToProps = dispatch => ({
  getApplicationNotifications: payload => dispatch(getApplicationNotifications(payload)),
  readApplicationNotification: payload => dispatch(readApplicationNotification(payload)),
  deleteReadNotification: payload => dispatch(deleteReadNotification(payload)),
  markNotificationSeen: payload => dispatch(markNotificationSeen(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NotificationCenter));
